export default __webpack_public_path__ + "static/media/Vipul Goyal.09768ae2.jpg";